import { onOutOfStockError, onBackorderError } from '../legacyAnalytics'

export const dataLayerRTIQueue = (backorderedItems, outOfStockItems, callback) => {
  const queue = []
  if (backorderedItems.length > 0) {
    queue.push(onBackorderError(backorderedItems))
  }
  if (outOfStockItems.length > 0) {
    queue.push(onOutOfStockError(outOfStockItems))
  }

  // setting a timeout to prevent each event to overwrite
  queue.forEach((item, index) => {
    setTimeout(() => {
      callback(item)
    }, 2000 * (index + 1))
  })
}
